import { mapActions } from "../reducer";

import { MapState } from '../../types';

export const updatePlannedRouteActiveCostType = (
  value: MapState['routes']['activeCostType']
) => mapActions.setActiveCostType(value);
